export const Permissions = {
  OrganizationCreate: "organization:create",
  OrganizationView: "organization:view",
  ConnectionView: "connection:view",
  DualloAdminView: "admin:view",

  OrganizationAdminView: "orgadmin:view",

  AIWorkflowView: "aiworkflow:view",
  AIWorkflowCreate: "aiworkflow:create",
  AIWorkflowUpdate: "aiworkflow:update",
  AIWorkflowDelete: "aiworkflow:delete",

  SiteView: "site:view",
  SiteCreate: "site:create",
  SiteUpdate: "site:update",
  SiteDelete: "site:delete",

  AssetView: "asset:view",
  ModelView: "model:view",
  HotspotView: "hotspot:view",
  AnomalyView: "anomaly:view",
  ReportsView: "reports:view",
  AssetAdminView: "asset-admin:view",

  AnomalyCreate: "anomaly:create",
  AnomalyUpdate: "anomaly:update",
  AnomalyDelete: "anomaly:delete",
  AnomalyComment: "anomaly:comment",
  AnomalyReview: "anomaly:review",

  SubscriptionView: "subscription:view",

  CategoryView: "category:view",

  AssetCreate: "asset:create",
  AssetUpdate: "asset:update",
  AssetDelete: "asset:delete",

  ModelVersionView: "modelversion:view",
  ModelVersionCreate: "modelversion:create",
  ModelVersionUpdate: "modelversion:update",

  ScanView: "scan:view",
  ScanCreate: "scan:create",
  ScanProcess: "scan:process",

  InspectionZoneView: "inspection-zone:view",
  InspectionZoneCreate: "inspection-zone:create",
  InspectionZoneUpdate: "inspection-zone:update",
  InspectionZoneDelete: "inspection-zone:delete",

  UserView: "user:view",
  UserCreate: "user:create",
  UserUpdate: "user:update",
  UserDelete: "user:delete",
  UserAssignRole: "user:assign-role",

  CategoryCreate: "category:create",
  CategoryUpdate: "category:update",
  CategoryDelete: "category:delete",

  SubscriptionUpdate: "subscription:update",

  HotspotCreate: "hotspot:create",
  HotspotUpdate: "hotspot:update",
  HotspotDelete: "hotspot:delete"
};